export class InputHarnessController {
  public emailValue: string;
  public passwordValue: string;
  public textValue: string;
}
